var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "ref_download", staticClass: "download" }, [
    _c("div", { staticClass: "header" }, [
      _c("img", {
        staticClass: "img-logo",
        attrs: { src: require("@/assets/download/bridge/logo.png"), alt: "" },
      }),
      _vm._v(" "),
      _c("p", { staticClass: "main-title" }, [
        _vm._v("都都GO 免费体验官活动来啦"),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cta",
          on: {
            click: function ($event) {
              return _vm.$router.push("/cn/download")
            },
          },
        },
        [_vm._m(1)]
      ),
    ]),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _c("footer", [
      _c("div", { staticClass: "container" }, [
        _c("p", { staticClass: "rights" }, [
          _vm._v("ⓒ 2021 Enuma, Inc. All Rights Reserved."),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("p", [_vm._v("深圳埃努码信息技术有限公司")]),
          _vm._v(" "),
          _c("p", { staticClass: "v-line" }),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: { cursor: "pointer" },
              on: {
                click: function ($event) {
                  return _vm.onClickFooterLink(0)
                },
              },
            },
            [_vm._v("粤ICP备2022075939号")]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "v-line" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ovcn",
              staticStyle: { cursor: "pointer" },
              on: {
                click: function ($event) {
                  return _vm.onClickFooterLink(1)
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/common/icn_beiangovcn.png"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c("p", [_vm._v("京公网安备 11010502050400号")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "深圳市南山区南头街道大汪山社区桃园东路1号 西海明珠花园F座2117-1"
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("img", {
      staticClass: "float-qr",
      attrs: { src: require("@/assets/download/bridge/qr.png"), alt: "" },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "cta float",
        on: {
          click: function ($event) {
            return _vm.$router.push("/cn/download")
          },
        },
      },
      [_vm._m(3)]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "main-desc" }, [
      _vm._v("都都运营团队暑期送好礼啦！"),
      _c("br", { staticClass: "mobile-show" }),
      _vm._v(
        "为答谢大家对都都思维产品的喜爱，都都运营团队决定开展“都都GO 暑期免费体验官”活动。"
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "inner" }, [
      _c("p", [_vm._v("点击下载App")]),
      _vm._v(" "),
      _c("img", {
        attrs: { src: require("@/assets/download/bridge/arrow.svg"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "body" }, [
      _c("div", { staticClass: "content1" }, [
        _c("p", { staticClass: "title" }, [_vm._v("免费体验时间")]),
        _vm._v(" "),
        _c("p", { staticClass: "desc" }, [_vm._v("6月21日19点-7月20日24点")]),
        _vm._v(" "),
        _c("img", {
          staticClass: "coupon",
          attrs: {
            src: require("@/assets/download/bridge/coupon.png"),
            alt: "",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "blue" }, [
          _c("div", { staticClass: "button" }, [_vm._v("活动对象")]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n                    2024年6月20日上午9点前，购买过都都思维半年卡及以上且还在有效期内的用户，均可获得价值128元的都都GO1个月免费使用权（包含7天试用)。\n                "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content11" }, [
        _c("img", {
          attrs: {
            src: require("@/assets/download/bridge/content11.png"),
            alt: "",
          },
        }),
        _vm._v(" "),
        _c("p", { staticClass: "desc" }, [
          _vm._v("\n                除此之外其他用户也可参与本次活动，"),
          _c("br"),
          _vm._v("我们为所有都都GO的新用户，提供7天免费试学。"),
          _c("br"),
          _vm._v("快来下载体验吧！\n            "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content2" }, [
        _c("p", { staticClass: "title" }, [_vm._v("体验流程")]),
        _vm._v(" "),
        _c("p", { staticClass: "desc" }, [
          _vm._v("需要使用和此前购买都都思维的同一手机号或 邮箱账号登陆"),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "process" }, [
          _c("li", [
            _c("img", {
              attrs: {
                src: require("@/assets/download/bridge/process1.png"),
                alt: "",
              },
            }),
            _vm._v(" "),
            _c("div", [
              _c("p", { staticClass: "index" }, [_vm._v("1")]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [_vm._v("扫码下载App")]),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("img", {
              attrs: {
                src: require("@/assets/download/bridge/process2.png"),
                alt: "",
              },
            }),
            _vm._v(" "),
            _c("div", [
              _c("p", { staticClass: "index" }, [_vm._v("2")]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [_vm._v("下载都都GO")]),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("img", {
              attrs: {
                src: require("@/assets/download/bridge/process3.png"),
                alt: "",
              },
            }),
            _vm._v(" "),
            _c("div", [
              _c("p", { staticClass: "index" }, [_vm._v("3")]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [_vm._v("登陆账号")]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "split" }),
      _vm._v(" "),
      _c("div", { staticClass: "content4" }, [
        _c("p", { staticClass: "title" }, [
          _vm._v(
            "\n                都都App暑期一站式搞定思维、英语学习\n            "
          ),
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/assets/download/bridge/content4.png"),
            alt: "",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "inner" }, [
      _c("p", [_vm._v("点击下载App")]),
      _vm._v(" "),
      _c("img", {
        attrs: { src: require("@/assets/download/bridge/arrow.svg"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }